import gql from 'graphql-tag';

export const AUTOCOMPLETE = gql`
  query Autocomplete($query: String!, $limit: Int) {
    globalAutocomplete(query: $query, limit: $limit) {
      items {
        ... on IndexedCustomer {
          id
          email
          name
          phone
        }
        ... on IndexedOrder {
          id
          completedAt
          deliveryAddress
          deliveryName
          egiftRecipientEmail
          egiftRecipientName
          merchantNames
          purchaserEmail
          purchaserName
          purchaserPhone
        }
      }
      totalCount
    }
  }
`;
